import { defineComponent as _defineComponent } from 'vue'
type Props = {
  /** 校友头像 */
  src?: string
  /** 校友姓名 */
  name?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SchoolPeople',
  props: {
    src: { default: '' },
    name: { default: '' }
  },
  setup(__props: any) {

const props = __props as { src: string, name: string };





return { __sfc: true,props }
}

})